import { render, staticRenderFns } from "./CarouselProducts.vue?vue&type=template&id=0f6645a7&scoped=true&"
import script from "./CarouselProducts.vue?vue&type=script&lang=js&"
export * from "./CarouselProducts.vue?vue&type=script&lang=js&"
import style0 from "./CarouselProducts.vue?vue&type=style&index=0&id=0f6645a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6645a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VRow,VSheet})
